import React from "react";
import "./App.css";
import { Route, Switch } from "react-router-dom";
import Navbar from "./components/navigation/navbar";
import CreateBookList from "./components/CreateBooksList";
import LendForm from "./components/LentForm";
import ShowBooks from "./components/showBooks";
import ShowDetails from "./components/ShowDetails";
import frontpage from "./components/frontpage";
import Error from './components/Error';
import AuthcontextProvider from "./context/Authcontext";
import BookContextProvider from "./context/BookContext";
import LentForm from "./components/LentForm";
import PrivateRoute from "./routes/PrivateRoute";
function App() {
  return (
    <React.Fragment>
      <AuthcontextProvider>
        <BookContextProvider>
          <Navbar />
          <Switch>
            <Route path="/" exact component={frontpage} />
            <PrivateRoute path="/show" exact component={ShowBooks} />
            <PrivateRoute path="/sort/:option" exact component={ShowBooks} />
            <PrivateRoute path="/sort/details/:bookId" exact component={ShowDetails} />
            <PrivateRoute path="/details/:bookId" exact component={ShowDetails} />
            <Route path="/error" exact component={Error} />
            <Route render={()=>(<h1>Page Not Found</h1>)} />
          </Switch>
        </BookContextProvider>
      </AuthcontextProvider>
    </React.Fragment>
  );
}

export default App;
